import React, { Component } from "react";
import { withRouter } from "../../../withRouter";

class AdminDashboard extends Component {
  render() {
    return <div>AdminDashboard</div>;
  }
}
export default withRouter(AdminDashboard);
